import { useMemo } from "react";
import { useFarm } from "../context/FarmContext";
import { computeFarmTasks } from "../Utils/farmTasks";

/**
 * The badge number for the way into the farmer's portal.
 *
 * Deliberately thin: the navbar renders on every page for every role, so this
 * must not pull the portal, OrdersTab or i18n namespaces along with it.
 */
const useFarmTasks = () => {
  const { isFarmer, farm, orders, products, baskets, loading } = useFarm();

  const tasks = useMemo(
    () => (isFarmer ? computeFarmTasks({ orders, products, baskets }) : null),
    [isFarmer, orders, products, baskets]
  );

  return {
    isFarmer,
    farm,
    loading,
    taskCount: tasks?.taskCount || 0,
    pendingOrderCount: tasks?.pendingOrders.length || 0,
  };
};

export default useFarmTasks;
